import { Trans, useTranslation } from 'react-i18next'

import { Alert, Link } from '@enechain/ecloud-designsystem'

import { EmailVerifiedStatus } from '~/gen/proto/bff/v1/model_pb'
import i18n from '~/i18n'

type Props = {
  status: EmailVerifiedStatus
}

export const EmailVerifiedAlert: React.FC<Props> = ({ status }: Props) => {
  const { t } = useTranslation()

  if (!status) {
    return null
  }

  switch (status) {
    case EmailVerifiedStatus.SUCCESS:
      return (
        <Alert
          status="success"
          title={t('pages.home.emailVerification.complete')}
          description={t('pages.home.emailVerification.completeDescription')}
        />
      )
    case EmailVerifiedStatus.ALREADY_VERIFIED:
      return (
        <Alert
          status="success"
          title={t('pages.home.emailVerification.alreadyVerified')}
          description={t(
            'pages.home.emailVerification.alreadyVerifiedDescription',
          )}
        />
      )
    case EmailVerifiedStatus.ERROR:
      return (
        <Alert
          status="error"
          title={t('pages.home.emailVerification.error')}
          description={
            <Trans
              components={{
                Inquiry: (
                  <Link
                    href={
                      i18n.language === 'en'
                        ? import.meta.env.VITE_ENG_INQUIRY_FORM_URL
                        : import.meta.env.VITE_INQUIRY_FORM_URL
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                ),
              }}
              i18nKey="pages.home.emailVerification.errorDescription"
            />
          }
        />
      )
    default:
      return null
  }
}
